import React from 'react';
import { FaAward, FaIndustry, FaGlobe, FaCheckCircle, FaLock } from 'react-icons/fa';
import './WhyChoose.css';

const WhyChoose = () => {
  const features = [
    { icon: <FaAward />, title: 'Proven Expertise', description: 'Across financial, operational, and IT domains' },
    { icon: <FaIndustry />, title: 'Industry Understanding', description: 'Strong grasp of sector-specific challenges' },
    { icon: <FaGlobe />, title: 'Global Exposure', description: 'Experienced leadership with international insights' },
    { icon: <FaCheckCircle />, title: 'Compliance-Focused', description: 'Audit-ready and regulatory aligned approach' },
    { icon: <FaLock />, title: 'Secure & Reliable', description: 'Highly professional and confidential engagements' }
  ];

  return (
    <section className="why-choose section">
      <div className="container">
        <div className="section-header center animate-on-scroll">
          <span className="section-label">Excellence</span>
          <h2>Why Choose Us</h2>
        </div>
        <div className="features-grid">
          {features.map((feature, index) => (
            <div key={index} className="feature-item animate-on-scroll">
              {feature.icon}
              <h4>{feature.title}</h4>
              <p>{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyChoose;
